export default class CommentsCommand {
    constructor(comments) {
        this.comments = comments;
    }
}